// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Controls_wrapper__26MHi","paragraph":"Controls_paragraph__1q9_6","parabola":"Controls_parabola__1wZDM"};